 /* globals urls */
(function($) {
	let refreshUpsells = false;
	$('.kois-billing-shipping .save-billing-details').click(function(e){
		e.preventDefault();
		var addressType = 'billing';
		var saveToCrm = $(this).hasClass('save-to-crm');
		var addressData = getCheckoutAddressData(addressType);

		if(addressData !== false){
			updateAddressSummary(addressType, addressData);
			updateSaveToCrmFlag(addressType, saveToCrm);
			$('.checkout-billing-edit-link').trigger('click');
		}
	});

	$('.kois-billing-shipping .save-shipping-details').click(function(e){
		e.preventDefault();
		var addressType = 'shipping';
		var saveToCrm = $(this).hasClass('save-to-crm');
		var addressData = getCheckoutAddressData(addressType);

		if(addressData !== false){
			updateAddressSummary(addressType, addressData);
			updateSaveToCrmFlag(addressType, saveToCrm);
			$('.checkout-shipping-edit-link').trigger('click');
		}
	});
	
	// When the payment options radio changes, get the correct payment details markup and show/hide the credit agreement
	$('input[type=radio][name=payment-options]').change(function() {
		var strPaymentOption = this.value;
		
		updatePaymentOptionDetails(strPaymentOption, this);
	});
	
	function updatePaymentOptionDetails(strPaymentOption, objPaymentOptions){
		// Block the payment options UI, a lá WooCommerce
		$('.payment-options').block({
			message: null,
			overlayCSS: {
				background: '#fff',
				opacity: 0.6
			}
		});

		// Trigger event so WooCommerce updates checkout totals based on new payment option data
		$( document.body ).trigger( 'update_checkout' );
	}

	// When WC emits the updated_checkout event, update the payment details markup for courses and show/hide credit agreement (if applicable)
	$( document.body ).on( 'updated_checkout', function(e, data){
		var paymentOptionFragment;
		var paymentOptionFragmentSelector = '.payment-options .expander.payment-option-details';
		// Do we have a fragment to replace the payment details with?
		try{
			paymentOptionFragment = data.fragments[paymentOptionFragmentSelector];
		}
		catch(err){paymentOptionFragment = null;}

		// If we do, swap the markup and show/hide the credit agreement as needed
		if (paymentOptionFragment) {
			var paymentOption = $('input[type=radio][name=payment-options]:checked').val();

			$(paymentOptionFragmentSelector).slideDown(400, function(){
				// Once close/open animation is complete, trigger an event to init magnific popup links if the user selected the plan option
				if(paymentOption === 'plan'){
					$('body').trigger('initPopups', ['.payment-option-details']);
				}

				// Show/hide the credit agreement field based on the new payment option
				if(paymentOption === 'deposit' || paymentOption === 'plan'){
					$('.checkout-row .credit-agreement').removeClass('hidden');
				}
				else{
					$('.checkout-row .credit-agreement').addClass('hidden');
				}
				
				// Remove the Payment options UI block now that the checkout page has been updated
				$('.payment-options').unblock();
			});
		}
		
	} );

	// When WooCommerce inserts a new state select box, make sure we wrap it in the correct div/class to make it all pretty
	$(document.body).bind( 'country_to_state_changing', function( event, country, wrapper ) {
		if ($('.selectbox-container input[type="text"]').length) {
			$('.selectbox-container input[type="text"]').unwrap();
		}
		$('select').not('.selectbox-container select').not('[multiple]').wrap('<div class="selectbox-container"></div>');
	});

	function getCheckoutAddressData(strAddressType){
		if(!isValidAddressType(strAddressType)){
			return false;
		}

		var objRet = {
			first: $('.kois-billing-shipping #'+strAddressType+'_first_name').val(),
			last: $('.kois-billing-shipping #'+strAddressType+'_last_name').val(),
			addr1: $('.kois-billing-shipping #'+strAddressType+'_address_1').val(),
			addr2: $('.kois-billing-shipping #'+strAddressType+'_address_2').val(),
			city: $('.kois-billing-shipping #'+strAddressType+'_city').val(),
			state: $('.kois-billing-shipping #'+strAddressType+'_state').val(),
			zip: $('.kois-billing-shipping #'+strAddressType+'_postcode').val(),
			country: $('.kois-billing-shipping #'+strAddressType+'_country').val(),
			phone: $('.kois-billing-shipping #'+strAddressType+'_phone').val() || null
		};

		var isDataValid = true;
		$.each(objRet, function(key, value){
			if('undefined' === typeof value){
				isDataValid = false;
			}
		});

		return (isDataValid ? objRet : false);
	}

	function updateAddressSummary(strAddressType, objAddressData){
		if(!isValidAddressType(strAddressType)){
			return false;
		}

		$('.kois-billing-shipping.'+strAddressType+'-block .checkout-name').html(objAddressData.first + ' ' + objAddressData.last);
		$('.kois-billing-shipping.'+strAddressType+'-block .checkout-addr1').html(objAddressData.addr1);
		$('.kois-billing-shipping.'+strAddressType+'-block .checkout-addr2').html(objAddressData.addr2);
		$('.kois-billing-shipping.'+strAddressType+'-block .checkout-city-state-zip').html(objAddressData.city + ', ' + objAddressData.state + ' ' + objAddressData.zip);
		$('.kois-billing-shipping.'+strAddressType+'-block .checkout-country').html(objAddressData.country);
		if(strAddressType === 'billing'){
			$('.kois-billing-shipping.'+strAddressType+'-block .checkout-phone').html(objAddressData.phone);
		}
	}

	function updateSaveToCrmFlag(strAddressType, blnSaveToCrm){
		if(!isValidAddressType(strAddressType)){
			return false;
		}

		$('#update_crm_'+strAddressType+'_address').val(blnSaveToCrm ? 1 : 0);
	}

	function isValidAddressType(strAddressType){
		if(strAddressType !== 'shipping' && strAddressType !== 'billing'){
			return false;
		}
		return true;
	}
	
	// Initializes KB/CC AJAX for applying/removing applied amounts
	function initKoistomerCreditsInteractions(){
		// Unbind any click events for these elements, to account for WooCommerce refreshing the markup based on cart changes
		$('#apply-kois-bucks-max, #apply-customer-credits-max, #remove-kois-bucks, #remove-customer-credits').unbind( 'click' );
		// Click events for applying max Kois Bucks and Customer Credits amounts to the user's cart
		$('#apply-kois-bucks-max, #apply-customer-credits-max').click(function(e){
			e.preventDefault();
			// Setup default data object for eventual AJAX call, including the AJAX action to start
			var data = {
				action: 'apply_koistomer_credits'
			};
			// Determine if we're applying KB or CC, and add the appropriate data to the object
			if( $(this).data( 'type' ) === 'cc' ){
				data.customer_credits = 'max';
			}
			else{
				data.kois_bucks = 'max';
			}
			
			// Make AJAX call to apply the max amount of KB/CC to the user's cart
			$.ajax({
				method: 'POST',
				url: urls.ajax,
				data: data
			})
			.done(function( res ) {
				// When complete, refresh the WooCommerce cart snippet(s) to display the applied amount or error message as appropriate
				$( document ).trigger( 'wc_update_cart' );
			});
		});
		// Click events for removing max Kois Bucks and Customer Credits amounts to the user's cart
		$('#remove-kois-bucks, #remove-customer-credits').click(function(e){
			e.preventDefault();
			// Setup default data object for eventual AJAX call, including the AJAX action to start
			var data = {
				action: 'unapply_koistomer_credits'
			};
			// Determine if we're removing KB or CC, and add the appropriate data to the object
			if( $(this).data( 'type' ) === 'cc' ){
				data.customer_credits = true;
			}
			else{
				data.kois_bucks = true;
			}
			
			// Make AJAX call to remove the max amount of KB/CC from the user's cart
			$.ajax({
				method: 'POST',
				url: urls.ajax,
				data: data
			})
			.done(function( res ) {
				// When complete, refresh the WooCommerce cart snippet(s) to display the removed amount or error message as appropriate
				$( document ).trigger( 'wc_update_cart' );
			});
		});
	}
	
	// Initialize interactions on page load
	initKoistomerCreditsInteractions();
	
	// After WC cart totals have been refreshed, trigger a refresh of the user's payment option details
	$( document ).on( 'updated_wc_div', function(){ $('input[type=radio][name=payment-options]').trigger( 'change' ); } );
	// After WC cart totals have been refreshed, initialize click events for Koistomer Credits UI elements which have been replaced in the markup by WC
	$( document ).on( 'updated_wc_div koistomer_credits_dom_updated', initKoistomerCreditsInteractions );
	//	when cart totals updated, rebind things. for the record, 'updated_shipping_method' would also work here
	$( document.body ).on( 'updated_cart_totals', initKoistomerCreditsInteractions );

	function initPrintedManualTriggerInteractions(){
		// Unbind any change events for these elements, to account for WooCommerce refreshing the markup based on cart changes
		$('.cart-course-printed-manual-trigger input[type=checkbox]').unbind( 'change' );
		
		// When a printed manual checkbox is changed, add/remove the appropriate data to the WC session
		$( '.cart-course-printed-manual-trigger input[type=checkbox]' ).change(function(){
			var input = $(this);
			var cartItemKey = input.data( 'cartitemkey' );
			// Make AJAX call to add/remove a printed manual to the appropriate enrollment
			$.ajax({
				method: 'POST',
				url: urls.ajax,
				data: {
					action: 'update_enrollment_printed_manual_value',
					cart_item_id: cartItemKey,
					include_manual: input.prop( 'checked' )
				}
			})
			.done(function( res ) {
				// When complete, refresh the WooCommerce cart snippet(s) to display the update course amount and/or message as appropriate
				$( document ).trigger( 'wc_update_cart' );
			});
		});

		// Tooltip to show additional info for printed manual option in cart
		$( '#prn-manual-note' ).hover(function(){
			$('#prn-manual-add-info').css('display', 'block');
		}, function(){
			$('#prn-manual-add-info').css('display', 'none');
		});
	}
	
	// Initialize interactions on page load
	initPrintedManualTriggerInteractions();
	
	// After WC cart totals have been refreshed, initialize click events for printed manual UI elements which have been replaced in the markup by WC
	$( document ).on( 'updated_wc_div', initPrintedManualTriggerInteractions );
	$( document ).on( 'updated_wc_div', initCourseAddOnTriggerInteractions );
	$( document ).on( 'updated_wc_div', initRemoveLink );
	$( document ).on( 'updated_wc_div', function(){
		if(refreshUpsells){initCourseUpsells();}
		refreshUpsells = false;
	});

	function initCourseAddOnTriggerInteractions(){
		
		$( '.js-add-course-add-on-to-cart' ).each(function(){
			$(this).unbind('click');
		});

		$( '.js-add-course-add-on-to-cart' ).each(function(){
			$(this).click(function(e){
				var input = $(this);
				var loader = $(this).parent().find('.add-on-loader');
				var cartItemKey = input.data( 'newenrollmentcartid' );
				var productId = input.data( 'productid' );
				var productName = input.data( 'itemname' );
				var cid = input.data( 'cid' );
				
				$( '.js-add-course-add-on-to-cart' ).each(function(){
					$(this).addClass('course-add-on-link--disabled');
					$(this).unbind('click');
					$(this).click(function(e){
						e.preventDefault();
					});
				});
				input.css('display', 'none');
				loader.css('display', 'unset');
	
				// Make AJAX call to add/remove a printed manual to the appropriate enrollment
				$.ajax({
					method: 'POST',
					url: urls.ajax,
					data: {
						action: 'add_course_add_on',
						productId: productId,
						newEnrollmentCartId: cartItemKey,
						name: productName,
						cId: cid
					}
				})
				.done(function( res ) {
					// When complete, refresh the WooCommerce cart snippet(s) to display the update course amount and/or message as appropriate
					$( document ).trigger( 'wc_update_cart' );
					//input.css('display', 'unset');
					$( '.js-add-course-add-on-to-cart' ).each(function(){
						$(this).removeClass('course-add-on-link--disabled');
					});
					loader.css('display', 'none');
				});
			});
		});

	}

	// Initialize interactions on page load
	initCourseAddOnTriggerInteractions();

	// Get the course upsells
	function initCourseUpsells(){
		$('.checkout-button').removeAttr('href');
		$('.checkout-button').attr('disabled', true);
		$('.checkout-button').addClass('loading');
		var upsellContainer = $('#course-upsells');
		upsellContainer.empty();

		// Make AJAX call to add/remove a printed manual to the appropriate enrollment
		$.ajax({
			method: 'POST',
			url: urls.ajax,
			data: {
				action: 'get_course_upsell_data',
			}
		})
		.done(function( res ) {
			var upsellContainer = $('#course-upsells');
			upsellContainer.empty();
			upsellContainer.append(res);

			$('body').trigger('initSeatingPopups');

			$('.checkout-button').attr('href', checkoutURL);
			$('.checkout-button').attr('disabled', false);
			$('.checkout-button').removeClass('loading');
		});
	}
	// check if the checkout button exists, if it does then we need to init the course upsells
	if ($('.checkout-button')[0]){
		initCourseUpsells();
	}
	

	// when a course is removed from the cart we need to refresh the course upsells
	function initRemoveLink(){
		$(".product-remove").on("click", function(){
			var removeLink = $(this).find(".remove");
			if(removeLink.data("is_course") === 1){
				refreshUpsells = true;
			}
		});
	}
	initRemoveLink();

	// give the course upsells a chance to load before users can continue to checkout
	var checkoutURL = $('.checkout-button').attr('href');
	$('.checkout-button').removeAttr('href');
	$('.checkout-button').attr('disabled', true);
	$('.checkout-button').addClass('loading');
	
})(jQuery);
